import { MarketType } from "../../../types";

export default function openDownloadPage(market: MarketType) {
  const marketText = market.toLowerCase();

  window.location.href = `https://trialmodeapp-redirection.worldfamilyenglish.com/redirect.html?campaign_id=${marketText}_thankyou`;
}
